/* eslint-disable no-param-reassign */

import { stopSubmit, reduxForm, change, FormErrors } from 'redux-form'
import { connect } from 'react-redux'
import size from 'lodash/size'
import forOwn from 'lodash/forOwn'
import { LKDate } from 'loankeeper-common/helpers/Date'
import createAction from 'loankeeper-common/helpers/createAction'
import isUndefined from 'lodash/isUndefined'
import { validationHelper } from '../DynamicFields'
import { actions as LKModalActions } from '../shared/LKModal'
import { clientContactVerifySMS } from 'src/store/client'

import {
  actionTypes,
  requestTypes,
  emailFields,
  FORM_NAME,
  individualIDCardNumbersCount,
  idCardNumbersCount,
  businessClient,
} from './constants'
import { translateLKMessage, translateWebMessage } from './translate'
import { clientCheckDublicate } from 'src/store/client'
import { AppDispatch } from 'src/store/index.d'

let cachedSubmitFn

export const getResubmit = () => cachedSubmitFn

// const isDuplicate = async (dupparams) => {
//   const response = await Client.checkDublicate(dupparams)
//   const { ClientDupCheckResponse } = response

//   return ClientDupCheckResponse.Result
// }

//UPDATED API REQUEST client_checkduplicate_api
const isDuplicate = async (dupparams, dispatch) => {
  const response = await dispatch(clientCheckDublicate(dupparams))
  if (!clientCheckDublicate.fulfilled.match(response)) {
    return response.payload
  }
}

const doNotMatch = (original, alt = 0) =>
  (original && original !== alt) || (alt && original !== alt) || (original && alt && original !== alt)

export const formChangeContainer = connect(undefined, (dispatch) => ({
  changeFormValue: (name, value) => {
    dispatch(change(FORM_NAME, name, value))
  },
}))

export default reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  touchOnChange: true,
  asyncBlurFields: ['CardNumber'],

  validate: (values: Record<string, any>, ownProps: Record<string, any>) => {
    const errors = {} as FormErrors<Record<string, unknown>, string>
    const { fields, dynamicFields, clientType, OpenDayStr, CellPhoneValidate } = ownProps

    forOwn(fields, ({ Active, FName, ObjName, NumField, MaxLen, MinLen, MinValue, MaxValue }) => {
      if (FName === 'FullName' && typeof values.FullName === 'string' && values.FullName.search('/') !== -1) {
        errors[FName] = translateLKMessage('ERR_DISALLOWED_CHAR') + ' /'
      }

      let cMinLen = 0
      let cMaxLen = 20
      const cNumField: number = 0

      if (
        !(
          (FName === 'CardNumber' || FName === 'CardNumberAlt') &&
          (values.IDCardTypeID === 7 || values.IDCardTypeID === 6)
        )
      ) {
        // for სხვა / Other ID card type
        cMinLen = MinLen
        cMaxLen = MaxLen
      }

      // if (
      //   (FName === 'CardNumber' || FName === 'CardNumberAlt') &&
      //   ownProps.clientType === businessClient &&
      //   ownProps.values.LegalStatusID === businessClient
      // ) {
      //   cMinLen = individualIDCardNumbersCount
      //   cMaxLen = individualIDCardNumbersCount
      // }
      const value = values[FName]

      // IBAN Validation
      if (fields.IBANAccNo && values.IBANAccNo && !/^[a-zA-Z0-9s]+$/.test(value)) {
        values.IBANAccNo = values.IBANAccNo.replace(/[^a-z0-9]/gi, '')
      }

      if (clientType === businessClient) {
        if (fields.Address2) {
          if (fields.Address2.Active === 1 && !values.AddressBus) {
            errors.AddressBus = translateLKMessage('ERR_REQUIRED_FIELD')
          }
        }

        if (fields.City2ID) {
          if (fields.City2ID.Active === 1 && values.CityBusID === 1) {
            errors.CityBusID = translateLKMessage('ERR_REQUIRED_FIELD')
          }
          if (fields.City2ID.Active === 1 && values.CityBusID !== 1) {
            values.City2ID = values.CityBusID
          }
        }
      }

      if (errors.Address2 && values.AddressBus) {
        values.Address2 = values.AddressBus
      }

      // Required validation
      if (Active === 1 && (!value || (ObjName.indexOf('lcb_') !== -1 && [0, 1].indexOf(parseInt(value, 10)) !== -1))) {
        errors[FName] = translateLKMessage('ERR_REQUIRED_FIELD')
      }

      if (NumField === 3 && value && !LKDate.isValid(value)) {
        errors[FName] = translateLKMessage('ERR_REQUIRED_FIELD_DATE')
      }

      // IsBefore date validation check
      if (
        NumField === 3 &&
        value &&
        !LKDate.isValid(value) &&
        MinValue &&
        LKDate.fromStd(value).compareString(MinValue) >= 0
      ) {
        errors[FName] = `${translateLKMessage('HINT_PROD_MIN')}${MinValue}`
      }

      // IsAfter date validation check
      if (
        NumField === 3 &&
        value &&
        !LKDate.isValid(value) &&
        MaxValue &&
        LKDate.fromStd(value).compareString(MaxValue) <= 0
      ) {
        errors[FName] = `${translateLKMessage('HINT_PROD_MAX')}${MaxValue}`
      }

      // NumberField validation
      if (cNumField === 1 && value && !/^[0-9]+$/.test(value)) {
        errors[FName] = `${translateLKMessage('HINT_ERR_NUMBER_ONLY')}`
      }

      // NumberField MinValue validation
      if (value && NumField === 1 && MinValue !== '' && value < MinValue) {
        errors[FName] = `${translateLKMessage('HINT_PROD_MIN')}${MinValue}`
      }

      // NumberField MaxValue validation
      if (value && NumField === 1 && MaxValue !== '' && value > MaxValue) {
        errors[FName] = `${translateLKMessage('HINT_PROD_MAX')}${MaxValue}`
      }

      // MaxLength validation for non date fields
      if (value && NumField !== 3 && value.toString().length > cMaxLen) {
        //exclude maxlength for business client id
        if (ownProps.clientType === businessClient && (FName === 'CardNumber' || FName === 'CardNumberAlt')) {
          return
        }
        errors[FName] = `${translateLKMessage('HINT_PROD_MAX')}${cMaxLen}`
      }

      // MinLength validation for non date fields
      if (value && NumField !== 3 && value.toString().length < cMinLen) {
        //exclude minLength for business client id
        if (ownProps.clientType === businessClient && (FName === 'CardNumber' || FName === 'CardNumberAlt')) {
          return
        }
        errors[FName] = `${translateLKMessage('HINT_PROD_MIN')}${cMinLen}`
      }
    })

    emailFields.forEach((fieldName) => {
      if (
        fields[fieldName] &&
        values[fieldName] &&
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values[fieldName])
      ) {
        errors[fieldName] = translateLKMessage('ERR_REQUIRED_FIELD_EMAIL')
      }
    })

    if (
      fields.IDCardRegDate &&
      fields.IDValidityDate &&
      (LKDate.fromStd(values.IDCardRegDate).compareString(values.IDValidityDate) > 0 ||
        LKDate.fromStd(values.IDCardRegDate).compareString(OpenDayStr) > 0)
    ) {
      errors.IDCardRegDate = translateLKMessage('ERR_CLIENT_IDCARD_LOGIC')
    }
    if (fields.IDValidityDate && LKDate.fromStd(values.IDValidityDate).compareString(OpenDayStr) < 0) {
      errors.IDValidityDate = translateLKMessage('ERR_CLIENT_IDCARD_LOGIC')
    }

    const validatedDynamicFields = validationHelper(values.DynFieldData || {}, dynamicFields)

    if (Object.keys(validatedDynamicFields).length) {
      // @ts-ignore
      errors.DynFieldData = validatedDynamicFields
    }
    if (clientType === businessClient) {
      // if (values.CardNumber) {
      //   if (values.LegalStatusID === businessClient) {
      //     if (values.CardNumber.toString().length > individualIDCardNumbersCount) {
      //       errors.CardNumber = `${translateLKMessage('HINT_PROD_MAX')}${individualIDCardNumbersCount}`
      //     }

      //     if (values.CardNumber.toString().length < individualIDCardNumbersCount) {
      //       errors.CardNumber = `${translateLKMessage('HINT_PROD_MIN')}${individualIDCardNumbersCount}`
      //     }
      //   } else {
      //     if (values.CardNumber.toString().length > idCardNumbersCount) {
      //       errors.CardNumber = `${translateLKMessage('HINT_PROD_MAX')}${idCardNumbersCount}`
      //     }

      //     if (values.CardNumber.toString().length < idCardNumbersCount) {
      //       errors.CardNumber = `${translateLKMessage('HINT_PROD_MIN')}${idCardNumbersCount}`
      //     }
      //   }
      // }
      if (errors.Address2 && fields.Address2.FName) {
        fields.Address2.FName = 'AddressBus'
      }

      if (errors.City2ID) {
        fields.City2ID.FName = 'CityBusID'
      }
    }

    if (clientType === 1) {
      if (values.OtherIDNumber !== values.OtherIDNumberAlt) {
        errors.OtherIDNumber = translateWebMessage('DO_NOT_MATCH')
        errors.OtherIDNumberAlt = translateWebMessage('DO_NOT_MATCH')
      }
    }

    if (!values.CardNumber) {
      errors.CardNumber = translateLKMessage('ERR_REQUIRED_FIELD')
    } else if (!values.CardNumberAlt) {
      errors.CardNumberAlt = translateLKMessage('ERR_REQUIRED_FIELD')
    }
    if (doNotMatch(values.CardNumber, values.CardNumberAlt)) {
      errors.CardNumber = translateWebMessage('DO_NOT_MATCH')
      errors.CardNumberAlt = translateWebMessage('DO_NOT_MATCH')
    }

    if (
      CellPhoneValidate === '1' &&
      fields?.CellPhone?.Active === 1 &&
      (values.action === requestTypes.add ||
        (values.action === requestTypes.update && values.CellPhone !== values.OrgCellPhone))
    ) {
      if (!isUndefined(values.CellPhone) && values.CellPhone.toString().length !== 9)
        errors.CellPhone = translateLKMessage('ERR_REQUIRED_FIELD')
      if (
        isUndefined(values.CellPhoneValidateCode) ||
        values.CellPhoneValidateCode.toString().length < 4 ||
        values.CodeVerifyPass === 0
      ) {
        if (isUndefined(values.CellPhoneValidateCode) && !errors.CellPhone)
          errors.CellPhone = `${translateLKMessage('ERR_REQUIRED_FIELD')} - Code`
        else errors.CellPhoneValidateCode = translateLKMessage('ERR_REQUIRED_FIELD')
      }
    }

    return errors
  },

  asyncValidate: async (values, dispatch: AppDispatch, { clientType, CellPhoneValidate, params }) => {
    const dupparams = {
      typeid: clientType,
      own_id: values.action === requestTypes.add ? 0 : values.ID,
      serial: values.CardNumber,
    }

    let request = null
    if (
      values.CodeVerifyPass === 1 &&
      CellPhoneValidate === '1' &&
      values.CellPhone !== '' &&
      values.CellPhoneValidateCode !== '' &&
      values.action !== requestTypes.update // NOT Editing
    ) {
      //UPDATED API REQUEST client_checkduplicate_api
      const resultDup = await isDuplicate(dupparams, dispatch)

      if (resultDup) {
        const errorMessage = translateLKMessage(resultDup)
        dispatch(LKModalActions.openError(errorMessage, resultDup))
        throw { CardNumber: errorMessage } // eslint-disable-line
      } else {
        let apiParams = {} as Record<string, any>
        if (values.action === requestTypes.update) {
          apiParams = {
            CellPhone: values.CellPhone,
            Code: values.CellPhoneValidateCode,
            ClientID: params.ID,
            ClientHash: params.hash,
            IDCardTypeID: values.IDCardTypeID,
          }
        } else {
          apiParams = {
            PersonalNo: values.CardNumber,
            CellPhone: values.CellPhone,
            Code: values.CellPhoneValidateCode,
            IDCardTypeID: values.IDCardTypeID,
          }
        }

        // @ts-ignore
        // request = Client.contactVerifySMS(apiParams)
        //   .then()
        //   .catch((err) => {
        //     const errorMessage = translateWebMessage(err.Message || (err.Error && err.Error.Text))
        //     dispatch(LKModalActions.openError(errorMessage, errorMessage))
        //     dispatch(stopSubmit(FORM_NAME))
        //     throw { CellPhoneValidateCode: errorMessage } // eslint-disable-line
        //   })

        //UPDATED API REQUEST client_contact_verify_api action: verify_sms
        try {
          const res = await dispatch(clientContactVerifySMS(apiParams))
          //@ts-ignore
          if (res.error) {
            const errorMessage = translateWebMessage(res.payload)
            dispatch(LKModalActions.openError(errorMessage, errorMessage))
            dispatch(stopSubmit(FORM_NAME))
            throw { CellPhoneValidateCode: errorMessage }
          }
        } catch (err) {
          const errorMessage = translateWebMessage(err.Message || (err.Error && err.Error.Text))
          dispatch(LKModalActions.openError(errorMessage, errorMessage))
          dispatch(stopSubmit(FORM_NAME))
          throw { CellPhoneValidateCode: errorMessage }
        }
      }
    } else {
      // request = Client.checkDublicate(dupparams).then((response) => {
      //   const { ClientDupCheckResponse } = response
      //   if (ClientDupCheckResponse.Result) {
      //     const errorMessage = translateLKMessage('ERR_DUPLICATE_CLIENT')
      //     dispatch(LKModalActions.openError(errorMessage, 'ERR_DUPLICATE_CLIENT'))
      //     throw { CardNumber: errorMessage } // eslint-disable-line
      //   }
      // })

      //UPDATED API REQUEST client_checkduplicate_api
      //@ts-ignore
      request = dispatch(clientCheckDublicate(dupparams)).then((response) => {
        if (!clientCheckDublicate.fulfilled.match(response)) {
          const errorMessage = translateLKMessage(response.payload)
          dispatch(LKModalActions.openError(errorMessage, response.payload))
          throw { CardNumber: errorMessage } // eslint-disable-line
        }
      })
    }
    return request
  },

  shouldAsyncValidate: (params) => {
    const { asyncErrors, trigger, pristine, initialized } = params

    switch (trigger) {
      case 'blur':
        return true

      case 'submit':
        // If there is async error dont't make another request
        if (size(asyncErrors)) {
          return false
        }

        return !pristine || !initialized

      default:
        return false
    }
  },

  onSubmitFail: (errors, dispatch) => {
    dispatch(stopSubmit(FORM_NAME))

    dispatch(
      LKModalActions.openError(
        errors.IND_DOB || translateLKMessage('ERR_FILL_REQUIRED_FIELDS'),
        'ERR_FILL_REQUIRED_FIELDS',
      ),
    )
  },

  onSubmit: (
    values,
    dispatch,
    { clientType, syncErrors, asyncErrors, fields, addClientInWatchList, modalName, onClientAddEdit, groupid, params },
  ) => {
    if (
      asyncErrors ||
      (syncErrors &&
        Object.keys(syncErrors).length &&
        !syncErrors.IND_ProfessionID &&
        !syncErrors.Address2 &&
        syncErrors.City2ID)
    ) {
      dispatch([stopSubmit(FORM_NAME), LKModalActions.openError(translateLKMessage('ERR_FILL_REQUIRED_FIELDS'))])
      return
    }

    const dynamicFieldsArray = Object.keys(values.DynFieldData || {})

    const APIparams = {
      ...values,
      IND_ProfessionID: values.IND_ProfessionID,
      ReqFieldGroupID: groupid,
      ZoneBusID: values.ZoneBusID || 1,
      DistrictBusID: values.DistrictBusID || 1,
      ORG_IndustryID: values.ORG_IndustryID || 1,
      ORG_IndustrySubDetailID: values.ORG_IndustrySubDetailID || 1,
      ORG_IndustrySubID: values.ORG_IndustrySubID || 1,
      DynFieldData: JSON.stringify({
        DynFieldData: dynamicFieldsArray.map((dynFieldKey) => ({
          Name: dynFieldKey,
          Value: values.DynFieldData[dynFieldKey].toString(),
        })),
      }),
    } as Record<string, any>

    if (clientType === 3) {
      APIparams.Address2 = APIparams.AddressBus
      APIparams.Address2_ALT = APIparams.AddressBus_ALT
      APIparams.City2ID = APIparams.CityBusID
    }

    cachedSubmitFn = async (sessionId, sessionHash, isResubmit = true) => {
      try {
        const response = await new Promise((resolve, reject) => {
          dispatch(
            createAction(
              actionTypes.SUBMIT,
              {
                params: APIparams,
                isResubmit,
                addClientInWatchList,
                sessionId,
                sessionHash,
              },
              { resolve, reject },
            ),
          )
        })

        dispatch([stopSubmit(FORM_NAME), LKModalActions.close(modalName), createAction(actionTypes.RESET)])

        if (onClientAddEdit) {
          onClientAddEdit(response, params)
        }
      } catch (error) {
        if (error.Error && error.Error.FailedFields) {
          // validate inputs if FailedFields exist
          const failed = error.Error.FailedFields.reduce((result, failedField) => {
            if (fields[failedField.FName]) {
              result[failedField.FName] = 'failed'
            } else {
              result.DynFieldData[failedField.FName] = 'failed'
            }

            return result
          }, {})

          dispatch(stopSubmit(FORM_NAME, failed))
        } else {
          dispatch(stopSubmit(FORM_NAME))
        }
      }
    }

    cachedSubmitFn(null, null, false)
  },
})
